import React, { Suspense, useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import { Ceo, ContactUs, JobAndCareer, NotFound, AtmBar, ViewRestaurants, Login, StaticPages, Franchise, RestaurantDetail, Checkout, LoginModal, CouponBooklet } from './components/pages';
import { Feedback, MyOrders, Notifications, NotificationSetting, OfferAndReward, OrderTracking, ProfileLayout, Settings, SideBarAddress, Wallet } from './components/profile';
import { EventDetailsPage } from './components/dashboard/tabs';
import { PaymentMethods, Dashboard, Layout, EditProfile, BookTableModal, ModalBox } from "./components"

import { GlobalContext } from './reducer/context';
import { callGetApi, callPostApi } from './api/ApiCaller';
import * as staticConstants from './translations/en/en';
import { SET_RESTAURANT_LIST } from './reducer/actions/utilityActions';
import * as ApiConst from './api/ApiConst';
import { EDIT_PROFILE, TOGGLE_EDIT_PROFILE_MODAL } from './reducer/actions/userActions';
import { NO_ERROR } from './api/constants';
import { useWindowSize } from './components/common/customHooks';
import { checkAvailableNearByOrderType } from './components/dashboard/common/DashboardUtils';
import { InformationAlert, PageLoader } from './components/common';
import MRPNight from './components/pages/Mrp-Night';
import LoginPageWrapper from './components/common/LoginPageWrapper';
import { OffersPage } from './components/profile/OffersPage';

const RouteConfig = () => {
    const { authState, userLocation, dispatchAuth, utilityStates, dispatchUtility } = useContext(GlobalContext);

    const { isAuthenticated } = authState;
    const { latitude, longitude } = userLocation;
    const size = useWindowSize();
    const retryCountRef = useRef(0);
    const restaurantIdRef = useRef(utilityStates.restaurantId);
    restaurantIdRef.current = utilityStates.restaurantId;

    const [searchParams] = useSearchParams();
    const queryParamsKeyValuePairs = Object.fromEntries([...searchParams])

    const getAllRestaurants = (force = false) => {
        if (force || !utilityStates.restaurantList) {
            const restaurantPayloadObj = {
                categoryId: 0,
                cityId: 0,
                latitude: latitude,
                longitude: longitude,
                length: 1000,
                orderType: staticConstants.ALL,
                searchKey: '',
                start: 0,
            };

            callPostApi(ApiConst.Post_Restaurant_List, restaurantPayloadObj, {}, (response) => {
                if (response.errorCode === NO_ERROR) {
                    if (!queryParamsKeyValuePairs.tableId && !queryParamsKeyValuePairs.orderType) {
                        checkAvailableNearByOrderType(response.responsePacket, dispatchUtility, restaurantIdRef.current);
                    }
                    dispatchUtility({ type: SET_RESTAURANT_LIST, payload: response.responsePacket });
                } else {
                    InformationAlert({ message: response.message });
                }
            }, error => {
                retryCountRef.current += 1
                if (retryCountRef.current <= 3) {
                    getAllRestaurants(force)
                }
            });
        }
    }
    
    // DEBUG: expose getAllRestaurants on window so it can be triggered manually
    // from the devtools console, e.g. `window.getAllRestaurants()`.
    // Re-attached every render so the console always calls the latest closure
    // (fresh latitude/longitude/state). Remove before shipping.
    // useEffect(() => {
    //     // Force the fetch by default so a bare `window.getAllRestaurants()`
    //     // always hits the API, even when restaurantList is already populated.
    //     window.getAllRestaurants = (force = true) => getAllRestaurants(force);
    //     return () => {
    //         delete window.getAllRestaurants;
    //     };
    // });

    const toggleProfileModal = () => {
        dispatchAuth({ type: TOGGLE_EDIT_PROFILE_MODAL })
    }

    // useEffect(() => {
    //     if (currentLocation) {
    //         dispatchLocation({ type: SET_LOCATION, payload: currentLocation });
    //     }
    // }, [currentLocation]);

    useEffect(() => {
        // getting restaurant list
        if (latitude && longitude) {
            getAllRestaurants()
        }
    }, [latitude, longitude]);

    useEffect(() => {
        if (isAuthenticated) {
            callGetApi(ApiConst.Get_Profile_Details, {}, (response) => {
                if (response.errorCode === NO_ERROR) {
                    dispatchAuth({ type: EDIT_PROFILE, payload: response.responsePacket });
                } else {
                    toast.error(response.message);
                }
            });
            // TODO
            // clevertapEvents.locationEvent(currentLocation)
        }
    }, [isAuthenticated]);




    return (
        <>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route path='/' element={<Layout />}>
                        <Route index element={<Dashboard />} />
                        <Route path='ceo' element={<Ceo />} />
                        <Route path='contact-us' element={<ContactUs />} />
                        <Route path='franchise' element={<Franchise />} />
                        <Route path='job-and-career' element={<JobAndCareer />} />
                        {/* <Route path='about-us' element={<StaticPages pageTitle='About Us' pagePath='AboutApp' />} /> */}
                        {/* <Route path='online-support' element={<StaticPages pageTitle='Chat With Us' pagePath='HelpAndSupport' />} /> */}
                        <Route path='privacy-policy' element={<StaticPages pageTitle='Privacy Policy' pagePath='PrivacyPolicy' />} />
                        <Route path='terms-and-conditions' element={<StaticPages pageTitle='Terms And Conditions' pagePath='TermsAndCondition' />} />
                        <Route path='atm-bar' element={<AtmBar />} />
                        <Route path='checkout' element={<Checkout />} />
                        <Route path='restaurants' element={<ViewRestaurants />} />
                        <Route path='restaurants/:restaurantUuid' element={<RestaurantDetail />} />
                        <Route path='event-detail/:eventId' element={<EventDetailsPage />} />
                        <Route path='payment-methods' element={<PaymentMethods />} />
                        <Route path='track-order' element={<OrderTracking />} />
                        {/* <Route path='special-occasion' element={<SpecialOccasion />}></Route> */}
                        <Route path='mrp-night' element={<MRPNight />}></Route>
                        {/* <Route path='add-customer' element={<AddCustomer />}></Route> */}
                        <Route element={<LoginPageWrapper />}>
                            <Route path='qr-scan' element={<OffersPage type={'scan'} />}></Route>
                            <Route path='qr-scan/:value' element={<OffersPage type={'scan'} />}></Route>
                            <Route path='qr-cash' element={<OffersPage type={'cash'} />}></Route>
                        </Route>
                        <Route element={<ProfileLayout />}>
                            <Route path='my-orders' element={<MyOrders />} />
                            <Route path='address' element={<SideBarAddress />} />
                            <Route path='wallet-money' element={<Wallet />} />
                            <Route path='offers' element={<OfferAndReward />} />
                            <Route path='feedback' element={<Feedback />} />
                            <Route path='notifications' element={<Notifications />} />
                            <Route path='notifications-setting' element={<NotificationSetting />} />
                            <Route path='settings' element={<Settings />} />
                        </Route>
                    </Route>
                    <Route path='/booklet/:uuid' element={<CouponBooklet />} />
                    <Route path='/booklet-template/:uuid' element={<CouponBooklet source='template' />} />
                    {size[0] <= 1080 ? <Route path='/login' element={isAuthenticated ? <Navigate to={"/"} /> : <Login />} /> : <Route path='/login' element={<Navigate to={"/"} />} />}
                    {/* {size[0] <= 1080 ? <Route path='/login' element={isAuthenticated ? <Navigate to={-1} /> : <Login />} /> : <Route path='/login' element={<Navigate to={-1} />} />} */}
                    <Route path='*' element={<NotFound title={staticConstants.PAGE_NOT_FOUND} />} />
                </Routes>

                {authState.showEditProfileModal && <ModalBox
                    headerTitle={Boolean(authState.user?.fullName) ? staticConstants.UPDATE_PROFILE : staticConstants.ADD_PROFILE}
                    show={authState.showEditProfileModal}
                    toggleModel={toggleProfileModal}
                // shouldCloseOnOverlayClick={!Boolean(authState.user?.fullName)}
                ><EditProfile /></ModalBox>}
                {authState.showLoginModal && <LoginModal />}
                {authState.showBookTableModal && <BookTableModal />}

            </Suspense>
        </>
    );
};

export default RouteConfig;
